import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import { GameCssStyles } from "../GameManagement/GameCssStyles";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const QuestionShowFilterPane = ({
  question_data,
  question_filter,
  showFilter,
  setShowFilter,
  applyFilter,
  setApplyFilter,
  handleClearFilters,
  entityNameFilter,
  setEntityNameFilter,
  entityCategoryFilter,
  setEntityCategoryFilter,
  entityDifficultyFilter,
  setEntityDifficultyFilter,
  questionStatusFilter,
  setQuestionStatusFilter,
  gameTypeFilter,
  setGameTypeFilter,
  vimeoIdFilter,
  setVimeoIdFilter,
  contentIdFilter,
  setContentIdFilter,
  createdAtStartFilter,
  setCreatedAtStartFilter,
  createdAtEndFilter,
  setCreatedAtEndFilter,
  updatedAtStartFilter,
  setUpdatedAtStartFilter,
  updatedAtEndFilter,
  setUpdatedAtEndFilter,
}) => {

  const toReadableLabel = (value) =>
    String(value || '')
      .replace(/[_-]+/g, ' ')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\b\w/g, (c) => c.toUpperCase())
      .trim();

  const getDifficultyLevelString = (difficulty) => {
    switch (difficulty) {
      case 0:
        return "Easy";
      case 1:
        return "Medium";
      case 2:
        return "Difficult";
      default:
        return "Unknown";
    }
  }

  const getDifficultyLevelValue = (difficulty) => {
    switch (difficulty?.toLowerCase()) {
      case "easy":
        return 0;
      case "medium":
        return 1;
      case "difficult":
        return 2;
      default:
        return "Unknown";
    }
  }

  return (
    showFilter && (
      <Box
        sx={{
          flex: 0.3,
          borderLeft: '1px solid #ccc',
          borderTop: '1px solid #ccc',
          borderBottom: '1px solid #ccc',
          backgroundColor: "whitesmoke",
          display: 'flex',
          flexDirection: 'column',
        }}>

        <Box
          sx={{
            flex: 1,
            width: '100%',
            height: '100%',
            display: "flex",
            flexDirection: "column",
            padding: 4,
            marginTop: '6vh',
            gap: 2,
            alignSelf: 'center',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}>

          <Typography variant="h6" gutterBottom>Filters</Typography>

          <Box
            sx={{
              flex: 1,
              height: 'auto',
              width: '100%',
              display: "flex",
              flexDirection: "column",
              gap: 2,
              alignSelf: 'center',
            }}>

            <FormControl
              fullWidth
              margin="normal"
              >
              <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Question Status</InputLabel>
              <Select
                value={questionStatusFilter}
                onChange={(e) => {
                  //console.log("answer release : ",e.target.value)
                  setQuestionStatusFilter(e.target.value)
                }}
                label="Question Status"
                sx={{ ...GameCssStyles.formFiledStyle_sx2}}
              >
                <MenuItem value="" disabled>
                  Select Question Status
                </MenuItem>
                {question_filter?.status?.map((item, idx) => {
                  return (<MenuItem key={idx} value={item} sx={GameCssStyles.menuItemStyle_sx}> {toReadableLabel(item)} </MenuItem>)
                })}
              </Select>
            </FormControl>

            <FormControl
              fullWidth
              margin="normal"
              style={{ marginTop: -1 }}
              >
              <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Difficulty Level</InputLabel>
              <Select
                value={entityDifficultyFilter}
                onChange={(e) => {
                  //console.log("answer release : ",e.target.value)
                  setEntityDifficultyFilter(e.target.value)
                }}
                label="Difficulty Level"
                sx={GameCssStyles.formFiledStyle_sx2}
              >
                <MenuItem value="" disabled>
                  Select Difficulty Level
                </MenuItem>
                {question_filter?.difficulty?.map((item, idx) => {
                  return (<MenuItem key={idx} value={item} sx={GameCssStyles.menuItemStyle_sx}> {getDifficultyLevelString(item)} </MenuItem>)
                })}
              </Select>
            </FormControl>

            <FormControl fullWidth margin="normal" style={{ marginTop: -1 }}>
              <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Game Type</InputLabel>
              <Select
                multiple
                value={gameTypeFilter || []}
                onChange={(e) => {
                  setGameTypeFilter(e.target.value);
                }}
                label="Game Type"
                renderValue={(selected) => (selected && selected.length > 0 ? selected.map(toReadableLabel).join(', ') : 'Select Game Type')}
                sx={GameCssStyles.formFiledStyle_sx2}
              >
                <MenuItem disabled value="">
                  Select Game Type
                </MenuItem>
                {question_filter?.gameType?.map((item, idx) => (
                  <MenuItem key={idx} value={item} sx={GameCssStyles.menuItemStyle_sx}>
                    <input
                      type="checkbox"
                      checked={gameTypeFilter?.indexOf(item) > -1}
                      readOnly
                      style={{ marginRight: 8 }}
                    />
                    {toReadableLabel(item)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              fullWidth
              label="Entity Name"
              variant="outlined"
              value={entityNameFilter}
              onChange={(e) => {
                setEntityNameFilter(e.target.value)
              }}
              sx={GameCssStyles.formSingleLineTextField_sx}
            />

            <FormControl
              fullWidth
              margin="normal"
              style={{ marginTop: 2 }}>
              <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>Entity Type</InputLabel>
              <Select
                value={entityCategoryFilter}
                onChange={(e) => {
                  //console.log("answer release : ",e.target.value)
                  setEntityCategoryFilter(e.target.value)
                }}
                label="Entity Type"
                sx={GameCssStyles.formFiledStyle_sx2}
              >
                <MenuItem value="" disabled>
                  Select Entity Type
                </MenuItem>
                {question_filter?.entityType?.map((item, idx) => {
                  const value = typeof item === 'object' ? item?.value : item;
                  const label = typeof item === 'object' ? (item?.label || toReadableLabel(item?.value)) : toReadableLabel(item);
                  return (<MenuItem key={idx} value={value} sx={GameCssStyles.menuItemStyle_sx}> {label} </MenuItem>)
                })}
              </Select>
            </FormControl>

            <TextField
              fullWidth
              label="Vimeo ID"
              variant="outlined"
              value={vimeoIdFilter}
              onChange={(e) => {
                setVimeoIdFilter(e.target.value)
              }}
              sx={{ ...GameCssStyles.formSingleLineTextField_sx, mt: -1 }}
            />

            <TextField
              fullWidth
              label="Content ID"
              variant="outlined"
              value={contentIdFilter}
              onChange={(e) => {
                setContentIdFilter(e.target.value)
              }}
              sx={GameCssStyles.formSingleLineTextField_sx}
            />

            <Box
              sx={{
                flex: 0,
                width: '100%',
                display: "flex",
                flexDirection: "column",
                gap: 2,
                textAlign: 'left',
              }}>
              <Typography variant="h6" gutterBottom>Created at</Typography>
              <Box
                sx={{
                  flex: 0,
                  display: "flex",
                  flexDirection: "row",
                  gap: 2,
                  alignSelf: 'center',
                  mt:-1
                }}>
                <DatePicker
                  label="Start at"
                  value={createdAtStartFilter ? dayjs(createdAtStartFilter) : null}
                  onChange={(v) => {
                    const formatted = v ? dayjs(v).format('YYYY-MM-DD') : '';
                    setCreatedAtStartFilter(formatted);
                  }}
                  slotProps={{ textField: { fullWidth: true, InputProps: { readOnly: true, disabled: true } } }}
                  sx={GameCssStyles.formSingleLineTextField_sx}
                />
                <DatePicker
                  label="End at"
                  value={createdAtEndFilter ? dayjs(createdAtEndFilter) : null}
                  onChange={(v) => {
                    const formatted = v ? dayjs(v).format('YYYY-MM-DD') : '';
                    setCreatedAtEndFilter(formatted);
                  }}
                  slotProps={{ textField: { fullWidth: true, InputProps: { readOnly: true, disabled: true } } }}
                  sx={GameCssStyles.formSingleLineTextField_sx}
                />
              </Box>
            </Box>

             <Box
              sx={{
                flex: 0,
                width: '100%',
                display: "flex",
                flexDirection: "column",
                gap: 2,
                textAlign: 'left',
              }}>
              <Typography variant="h6" gutterBottom>Updated at</Typography>
              <Box
                sx={{
                  flex: 0,
                  display: "flex",
                  flexDirection: "row",
                  gap: 2,
                  alignSelf: 'center',
                  mt:-1
                }}>
                <DatePicker
                  label="Start at"
                  value={updatedAtStartFilter ? dayjs(updatedAtStartFilter) : null}
                  onChange={(v) => {
                    const formatted = v ? dayjs(v).format('YYYY-MM-DD') : '';
                    setUpdatedAtStartFilter(formatted);
                  }}
                  slotProps={{ textField: { fullWidth: true, InputProps: { readOnly: true, disabled: true } } }}
                  sx={GameCssStyles.formSingleLineTextField_sx}
                />
                <DatePicker
                  label="End at"
                  value={updatedAtEndFilter ? dayjs(updatedAtEndFilter) : null}
                  onChange={(v) => {
                    const formatted = v ? dayjs(v).format('YYYY-MM-DD') : '';
                    setUpdatedAtEndFilter(formatted);
                  }}
                  slotProps={{ textField: { fullWidth: true, InputProps: { readOnly: true, disabled: true } } }}
                  sx={GameCssStyles.formSingleLineTextField_sx}
                />
              </Box>
            </Box>

          </Box>

          <Box
            sx={{
              flex: 0,
              width: '100%',
              display: "flex",
              flexDirection: "row",
              gap: 5,
              alignSelf: 'center',
              mt:3
            }}>

            <Button
              variant="contained"
              color="success"
              sx={{
                alignSelf: 'center',
                borderRadius: 2,
                textTransform: "none",
                px: 4,
                flex:1,
              }}
              onClick={() => {
                setApplyFilter(true)
                setShowFilter(false)
              }}>
              Apply
            </Button>

            <Button
              variant="contained"
              color="error"
              sx={{
                alignSelf: 'center',
                borderRadius: 2,
                textTransform: "none",
                px: 4,
                flex:1,
              }}
              onClick={() => {
                handleClearFilters()
                setShowFilter(false)
              }}>
              Clear
            </Button>

          </Box>

        </Box>

      </Box>
    )
  );
}


export default QuestionShowFilterPane;